/**
 * formatStacks — compact soft-currency formatting for the crew UI.
 *
 * Shared by FriendCell, PlayerCard, and SearchTab so the balance shown for a
 * player is identical wherever it appears (e.g. 5_000_000 → "5M", 12_345 → "12K").
 */
export function formatStacks(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(n >= 10_000 ? 0 : 1)}K`;
  return String(n);
}
